export default "__VITE_ASSET__BQF5CjjQ__"